import { useState as l, useCallback as s } from "react";
const c = () => {
  const [o, e] = l(!1), t = s(() => {
    e(!0);
  }, [e]), a = s(() => {
    e(!1);
  }, [e]);
  return { isOpen: o, openModal: t, closeModal: a };
};
export {
  c as u
};
